import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex w-full justify-center bg-[#2D2924] bg-[url(/media/banner/subscription/subscription-banner-mobile.webp)] bg-cover px-[12px] sm:bg-[url(/media/banner/subscription/subscription-banner.webp)] sm:px-0',
    wrap: 'container flex flex-col gap-8 px-0 pt-[36px] pb-[20px] sm:flex-row sm:px-[75px] sm:pt-[48.25px] sm:pb-[46.75px]',
    brandImage: 'hidden h-133 w-121.5 self-end lg:block',
    content:
      'flex flex-col gap-[24px] sm:flex-row sm:items-center sm:gap-[64px]',
    title:
      'font-regular text-lg leading-[120%] tracking-[0.02] text-white sm:text-2xl',
    formWrap: 'flex flex-col gap-[16px] sm:gap-[12px]',
    form: 'flex gap-6 max-lg:flex-col',
    button: 'group h-fit border-0 p-0 hover:bg-transparent',
    disclaimer:
      'text-sm leading-[1.4] font-light text-white underline-offset-4',
    approvalLink: 'link underline underline-offset-4',
    successMessage:
      'font-regular hidden text-lg leading-[120%] tracking-[0.02] text-white sm:text-2xl',
    claims: '',
    icon: 'group-hover:[&>path]:fill-brand-400 size-[24px] [&>path]:fill-white'
  },
  variants: {
    loginStatus: {
      guest: 'text-main',
      loggedIn: {
        base: 'mt-0! mb-10 bg-transparent p-0!',
        wrap: 'hidden',
        claims: 'relative translate-0 bg-transparent p-0 lg:p-0'
      }
    },
    formStatus: {
      default: '',
      error: '',
      success: {
        base: 'mt-17 max-lg:pt-22.5 max-lg:pb-34.25',
        content: 'py-[29.5px] max-lg:py-[29.5px]',
        title: 'hidden',
        formWrap: 'hidden',
        successMessage: 'block'
      }
    }
  },
  defaultVariants: {
    loginStatus: 'guest',
    formStatus: 'default'
  }
});
